import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import Accordion from '../../Accordion';
import { Locales } from '../../../store/setLocales';
import { setUserLocale } from '../../../containers/App/actions';
import { Translate } from 'react-redux-i18n';
import { InfosFields } from '../styles';

interface LanguageSelectorProps {
	language: string;
	dispatch: Dispatch<StoreState>;
}

class LanguageSelector extends React.Component<LanguageSelectorProps, {}> {
	constructor(props: LanguageSelectorProps) {
		super(props);
		this.setLanguage = this.setLanguage.bind(this);
	}

	setLanguage(locale: string): void {
		const { dispatch } = this.props;
		dispatch(setUserLocale(locale, true));
	}

	renderLanguageList() {
		const { language } = this.props;
		return Object.keys(Locales).map(locale => {
			return (
				<InfosFields
					key={locale}
					onClick={() => this.setLanguage(locale)}
					isActive={language === locale}
				>
					<Translate value={`languages.${locale}`} />
				</InfosFields>
			);
		});
	}

	render() {
		const { language } = this.props;
		return (
			<Accordion
				title="messages.language"
				selectedOption={`languages.${language}`}
				isOpened={false}
			>
				{this.renderLanguageList()}
			</Accordion>
		);
	}
}

export default LanguageSelector;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/Language/index.tsx